export default {
  DRAFT: "draft",
  PUBLISHED: "published",
  ARCHIVED: "archived",
};
